import { api } from "../api";

export const PropostaService = {
    responderProposta: async (token, data) => {
        const response = await api.post(`/propostas/responder`, data, {
            headers: { "Authorization": token }
        });

        return response.data;
    },
    getPropostasAgrupadoByCodCli: async (token, codCli, dataInicio, dataFim, paged = true, page = 1, limit = 5) => {
        const url = paged ? `/propostas/${codCli}/agrupado?dataInicio=${dataInicio}&dataFim=${dataFim}&page=${page}&limit=${limit}` :
            `/propostas/${codCli}/agrupado?dataInicio=${dataInicio}&dataFim=${dataFim}`;

        const headers = { "Authorization": token };
        if (paged) headers["X-Paginate"] = true;

        const response = await api.get(url, { headers });
        return response.data;
    },
    getPropostasAgrupado: async (token, dataInicio, dataFim, paged = true, page = 1, limit = 5) => {
        const url = paged ? `/propostas/agrupado?dataInicio=${dataInicio}&dataFim=${dataFim}&page=${page}&limit=${limit}` :
            `/propostas/agrupado?dataInicio=${dataInicio}&dataFim=${dataFim}`;

        const headers = { "Authorization": token };
        if (paged) headers["X-Paginate"] = true;

        const response = await api.get(url, { headers });
        return response.data;
    },
    getPropostasPendentesAgrupado: async (token, comResp = 0, dataInicio, dataFim, paged = true, page = 1, limit = 5) => {
        const url = paged ? `/propostas/pendente/agrupado?comResp=${comResp}&dataInicio=${dataInicio}&dataFim=${dataFim}&page=${page}&limit=${limit}` :
            `/propostas/pendente/agrupado?comResp=${comResp}&dataInicio=${dataInicio}&dataFim=${dataFim}`;

        const headers = { "Authorization": token }; 
        if (paged) headers["X-Paginate"] = true;

        const response = await api.get(url, { headers });
        return response.data;
    },
    getPropostas: async (token, dataInicio, dataFim, ordcom = 0, paged = false, page = 1, limit = 5) => {
        let url = paged ? `/propostas?dataInicio=${dataInicio}&dataFim=${dataFim}&page=${page}&limit=${limit}` :
            `/propostas?dataInicio=${dataInicio}&dataFim=${dataFim}`;

        if (ordcom > 0) url += `&ordcom=${ordcom}`

        const headers = { "Authorization": token };
        if (paged) headers["X-Paginate"] = true;

        const response = await api.get(url, { headers });
        return response.data;
    },
    getPropostasByCodCli: async (token, codCli, ordcom, dataInicio, dataFim, paged = true, page = 1, limit = 5) => {
        let url = paged ? `/propostas/${codCli}?dataInicio=${dataInicio}&dataFim=${dataFim}&page=${page}&limit=${limit}` :
            `/propostas/${codCli}?dataInicio=${dataInicio}&dataFim=${dataFim}`;

        if (ordcom > 0) url += `&ordcom=${ordcom}`
        
        const headers = { "Authorization": token };
        if (paged) headers["X-Paginate"] = true;

        const response = await api.get(url, { headers });
        return response.data;
    },
    getRespostasByArq281: async (token, arq281) => {
        const response = await api.get(`/propostas/${arq281}/respostas`, {
            headers: { "Authorization": token }
        });
        return response.data;
    },
    filtrarPropostas: async (token, data, paged = true, page = 1, limit = 5) => {
        const url = paged ? `/propostas/filtrar?page=${page}&limit=${limit}` : '/propostas/filtrar';
        const headers = { "Authorization": token };
        if (paged) headers["X-Paginate"] = true;

        const response = await api.post(url, data, { headers });
        return response.data;
    },
}; 